// extracted by mini-css-extract-plugin
export default {"column-select":"ldoHZ"};